import config from '@/types/config';

import Analytics from './AnalyticsProvider';
import AmplitudeProvider from './providers/AmplitudeProvider';
import FacebookPixelProvider from './providers/FacebookPixel';
import TikTokPixelProvider from './providers/TikTokPixel';
import AppsFlyerProvider from './providers/AppsFlyerProvider';

const analytics = new Analytics();

analytics.addProvider(new AmplitudeProvider(config.amplitudeApiKey));
analytics.addProvider(new FacebookPixelProvider());
analytics.addProvider(new TikTokPixelProvider());
analytics.addProvider(new AppsFlyerProvider());

analytics.mapEvent('webContentLinkOpened', {
  amplitude: 'WebContent_Link_Opened',
});

analytics.mapEvent('webContentElementClicked', {
  amplitude: 'WebContent_Element_Clicked',
});

analytics.mapEvent('webOnboardingOpened', {
  amplitude: 'WebOnboarding_Opened',
});

analytics.mapEvent('webOnboardingFullyLoaded', {
  amplitude: 'WebOnboarding_FullyLoaded',
});

analytics.mapEvent('webOnboardingScreenOpened', {
  amplitude: 'WebOnboarding_Screen_Opened',
});

analytics.mapEvent('webOnboardingQuestionAnswered', {
  amplitude: 'WebOnboarding_Question_Answered',
});

analytics.mapEvent('webOnboardingLegalDocsClicked', {
  amplitude: 'WebOnboarding_LegalDocs_Clicked',
});

analytics.mapEvent('webOnboardingClaimClicked', {
  amplitude: 'WebOnboarding_Claim_Clicked',
});

analytics.mapEvent('webOnboardingConnectClicked', {
  amplitude: 'WebOnboarding_Connect_Clicked',
});

analytics.mapEvent('webOnboardingGetStartedClicked', {
  amplitude: 'WebOnboarding_GetStarted_Clicked',
});

analytics.mapEvent('authPhoneNumberInputSelected', {
  amplitude: 'Auth_PhoneNumberInput_Selected',
});

analytics.mapEvent('authSendCodeClicked', {
  amplitude: 'Auth_SendCode_Clicked',
});

analytics.mapEvent('authOTPInputSelected', {
  amplitude: 'Auth_OTPInput_Selected',
});

analytics.mapEvent('authSignUpClicked', {
  amplitude: 'Auth_SignUp_Clicked',
});

analytics.mapEvent('authOTPResendClicked', {
  amplitude: 'Auth_OTPResend_Clicked',
});

analytics.mapEvent('authStarted', {
  amplitude: 'Auth_Started',
});

analytics.mapEvent('authSucceeded', {
  amplitude: 'Auth_Succeeded',
});

analytics.mapEvent('authFailed', {
  amplitude: 'Auth_Failed',
});

analytics.mapEvent('plaidConnectionStarted', {
  amplitude: 'PlaidConnection_Started',
});

analytics.mapEvent('plaidConnectionSucceed', {
  amplitude: 'PlaidConnection_Succeed',
  facebook: 'Lead',
  tiktok: 'Lead',
  appsFlyer: 'af_connect_account',
});

analytics.mapEvent('plaidConnectionFailed', {
  amplitude: 'PlaidConnection_Failed',
});

analytics.mapEvent('webToAppButtonClicked', {
  amplitude: 'WebToApp_Button_Clicked',
});

analytics.mapEvent('completeRegistration', {
  facebook: 'CompleteRegistration',
  appsFlyer: 'af_complete_registration',
});

export default analytics;
